<template>
    <div class="users">
        <v-container>
                <users-table></users-table>
        </v-container>
    </div>
</template>

<script>
    import usersTable from '../components/users/table'
    export default {
        name: "users",
        components: {
            usersTable
        },
        data() {
            return {
            }
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>